import { render, staticRenderFns } from "./Hosgeldin.vue?vue&type=template&id=15713354&"
import script from "./Hosgeldin.vue?vue&type=script&lang=js&"
export * from "./Hosgeldin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports